import useSWR from "swr";


type LineAccount = {
  id: string;
  customer_sex: string;
  customer_birth_year: string;
  customer_birth_month: string;
  line_id: string;
  display_name: string;
  picture_url?: string;
  visit_count: number;
  registered_date: string;
  last_visit: string;
  is_active: boolean;
  blocked_date: null | string;
  customer: string;
  restaurant: string;
};
type QuestionAnswers = {
  id: string;
  line_account: LineAccount;
  answer_score: number;
  answered_at: string;
}[];
type PaginatedQuestionAnswers = {
  count: number;
  question: string;
  question_answer_scores: QuestionAnswers;
  page_size: number;
};
export const useFetchPaginatedQuestionAnswers = (staffId?: string, questionId?: string, queryParams?: URLSearchParams) => {
  const fetchKey = staffId && questionId ? `restaurant_staff/staff/${staffId}/survey/questions/${questionId}/answers/paginated/${queryParams?.toString() && `?${queryParams}`}` : null;
  const { data: paginatedQuestionAnswers, error, isLoading } = useSWR<PaginatedQuestionAnswers>(fetchKey)
  return { paginatedQuestionAnswers, isLoading, error };
};